import { computed } from "vue";
import { AxiosError } from "axios";
import type { Ref } from "vue";
import { getServerError } from "@/utils/getServerError";

export function useServerError(error: Ref<unknown>, fieldMapping: { [key: string]: string } = {}) {
  const errorMessage = computed(() => {
    if (error.value instanceof AxiosError) {
      return getServerError(error.value, fieldMapping);
    } else {
      return "An unknown error occurred.";
    }
  });

  return { errorMessage };
}
